import {
  getEnvFromHostname,
  RuntimeEnvironmentOptions,
} from "@growtherapy/analytics";
import { logger } from "../datadog";
import * as FS from "@fullstory/browser";

export function stopFullStory() {
  if (
    getEnvFromHostname({ hostname: location.hostname }) ===
    RuntimeEnvironmentOptions.local
  )
    return;
  FS.shutdown();
}

export function startFullStory() {
  if (
    getEnvFromHostname({ hostname: location.hostname }) ===
    RuntimeEnvironmentOptions.local
  )
    return;
  FS.restart();
}

export function setUserId(userId: string) {
  if (
    getEnvFromHostname({ hostname: location.hostname }) ===
    RuntimeEnvironmentOptions.local
  ) {
    logger.debug("Setting FullStory user ID", { userId });
    return;
  }
  FS.identify(userId);
}

export function setUserVars(userVars: Record<string, unknown>) {
  if (
    getEnvFromHostname({ hostname: location.hostname }) ===
    RuntimeEnvironmentOptions.local
  ) {
    logger.debug("Setting FullStory user vars", userVars);
    return;
  }
  FS.setUserVars(userVars);
}
